export { ClientOnly };

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import type {
  ComponentProps,
  ComponentType,
  LazyExoticComponent,
  ReactElement,
  ReactNode,
} from 'react';
import { Suspense, lazy, useEffect, useState } from 'react';

function ClientOnly<
  // @TODO biome-ignore lint/suspicious/noExplicitAny:
  const C extends () => Promise<{ default: ComponentType<any> }>,
  const F extends ReactNode | ReactElement,
>({
  children,
  component,
  ...props // @TODO biome-ignore lint/suspicious/noExplicitAny:
}: { children?: F; component: C } & ComponentProps<ComponentType<any>>) {
  // @TODO biome-ignore lint/suspicious/noExplicitAny:
  const [Component, setComponent] = useState<LazyExoticComponent<any>>();

  useEffect(() => {
    setComponent(() => lazy(component));
  }, []);

  return (
    <ErrorBoundary
      fallback={
        <div className="flex grow flex-col items-center justify-center">
          <div className="my-auto flex flex-row items-center space-x-2 text-center text-sm">
            <ExclamationCircleIcon className="h-6 w-6" />
            <span>
              Something went wrong while loading this section.{' '}
              <a href="#" onClick={() => location.reload()}>
                Refresh
              </a>{' '}
              to try again?
            </span>
          </div>
        </div>
      }
    >
      <Suspense fallback={children}>{Component ? <Component {...props} /> : children}</Suspense>
    </ErrorBoundary>
  );
}
